(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bindMuteToggles() {
      const toggles = document.querySelectorAll('[data-mute]');
      toggles.forEach((toggle) => {
        // this would retrieve the value for <tag data-loaded="someValueForLoaded"></tag>
        // it will initially not exist which will then go into this if statement
        if (!toggle.dataset.loaded) {
          const id = toggle.dataset.mute;
          const video = document.getElementById(id);

          if (video) {
            toggle.dataset.loaded = true;
            toggle.addEventListener('click', () => {
              video.muted = !video.muted;
              toggle.classList.toggle('is-active', !video.muted);
            });
          }
        }
      });
    }

    document.addEventListener('shopify:section:load', () => {
      bindMuteToggles();
    });

    window.addEventListener('load', () => {
      bindMuteToggles();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
